export const DEFAULT_INVOICE_TERMS = [
  'Memberships are non-transferable, non-refundable and expire after the validity period.',
  'Credits must be used within the validity period stated at purchase.',
  'Cancellations must be made at least 12 hours before class start time.',
  'Late cancellations may result in forfeiture of the session credit.',
  'Please arrive 10 minutes before class start time.',
  'Carry a personal mat towel and water bottle.',
  'Studio reserves the right to refuse entry for hygiene or safety reasons.',
].join('\n');
